import { createContext, useEffect, useState } from 'react';

import { useUnmount } from '@ava/components/hooks';

import { Campaign } from 'interfaces/CRM/Campaign';
import { GetInitialDataResponse } from 'interfaces/CRM/Responses/GetInitialDataResponse';
import { ServiceFlow } from 'interfaces/CRM/ServiceFlow';
import { myQueueService } from 'subjects/CRM/MyQueueService';

export type MyQueueContextType = {
    campaigns: Campaign[] | null;
    initialData: GetInitialDataResponse | null;
    serviceFlows: ServiceFlow[] | null;
};

export const MyQueueContext = createContext<MyQueueContextType>({
    campaigns: null,
    initialData: null,
    serviceFlows: null,
});

const MyQueueContextProvider = ({ children, initialData }) => {
    const unmountSub = useUnmount();

    const [campaigns, setCampaigns] = useState<Campaign[] | null>(null);
    const [serviceFlows, setServiceFlows] = useState<ServiceFlow[] | null>(null);

    useEffect(() => {
        unmountSub(
            myQueueService.getCampaigns$(),
            (response) => {
                setCampaigns(response?.value ?? []);
            },
            () => {
                setCampaigns([]);
            },
        );
        unmountSub(
            myQueueService.getServiceFlows$(),
            (activeServiceFlows) => {
                setServiceFlows(activeServiceFlows);
            },
            () => {
                setServiceFlows([]);
            },
        );
    }, []);

    return (
        <MyQueueContext.Provider value={{ campaigns, initialData, serviceFlows }}>{children}</MyQueueContext.Provider>
    );
};

export default MyQueueContextProvider;
